<template lang="pug">
  .component.component-backoffice-vehicle-slot(v-if="item")
    .card( v-if="$is('listing')")
      .inner-content
        cardN(:showBullets="true", :showAction="true", :columns="6")
          div(slot="actionBullets")
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              vehicle-slot-buttons(:vehicle="item")
          vehicle-fields(slot="n1", :item="item", :fieldName="'vehicle-image'")
          vehicle-fields(slot="n2", :item="item", :fieldName="'vehicle-id'")
          vehicle-fields(slot="n2", :item="item", :fieldName="'vehicle-brand-and-lot'")
          vehicle-fields(slot="n3", :item="item", :fieldName="'vehicle-plate'")
          vehicle-fields(slot="n4", :item="item", :fieldName="'vehicle-category'")
          template(slot="n4" v-if="item.segment")
            .field-segment
              .label Segment
              .field-value SG{{item.segment.id}} {{item.segment.name}}
          vehicle-fields(slot="n5", :item="item", :fieldName="'vehicle-lot'")
          vehicle-fields(slot="n6", :item="item", :fieldName="'vehicle-status'")
          vehicle-fields(slot="n6", :item="item", :fieldName="'vehicle-additional-status'")
          div.pl-2(slot="actionPage")
            router-link(:to="{name:'vehicle', params:{id:item.id}}")
              i.fa.fa-angle-right.fa-3x.action
    .maintenance(v-if="$is('maintenance')")
      vehicle-fields(:item="item", :fieldName="'vehicle-status'")
      vehicle-fields(:item="item", :fieldName="'vehicle-additional-status'")
    .one-look(v-if="$is('oneLook')")
      router-link(:to="{name:'vehicle',params:{id:item.id}}") {{item.brand}} {{item.model}}
      router-link.hollow.button.secondary.small(:to="{name:'vehicle', params:{id:item.id}}") {{item.plate}}
    .asset-management-list(v-if="$is('asset-management-list')")
      .vehicle-id-and-name {{item.brand}} {{item.model}} (V{{item.id}})
      vehicle-fields(:item="item", :fieldName="'vehicle-plate'")
    .category-listing(v-if="$is('category-listing')")
      cardN(:showBullets="true", :showAction="true", :columns="4")
        div(slot="actionBullets")
          dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
            vehicle-slot-buttons(:vehicle="item")
        img(slot="n1", :src="item.picture_external", width="100")
        vehicle-fields(slot="n1", :item="item", :fieldName="'vehicle-id'")
        vehicle-fields(slot="n2", :item="item", :fieldName="'vehicle-brand'")
        vehicle-fields(slot="n2", :item="item", :fieldName="'vehicle-plate'")
        vehicle-fields(slot="n3", :item="item", :fieldName="'vehicle-lot'")
        vehicle-fields(slot="n4", :item="item", :fieldName="'vehicle-status'")
        div(slot="actionPage")
          router-link(:to="{name:'vehicle', params:{id:item.id}}")
            i.fa.fa-angle-right.fa-3x.action

    .fleet-map(v-if="$is('fleet-map')")
      cardN(:showBullets="false", :showAction="true", :columns="5")
        //div(slot="actionBullets")
        vehicle-fields(slot="n1", :item="item", :fieldName="'vehicle-brand'")
        div(slot="n1")
          span
            img(:src="item.picture_external", width="100")
        vehicle-fields(slot="n1", :item="item", :fieldName="'vehicle-lot'")
        vehicle-fields(slot="n2", :item="item", :fieldName="'vehicle-plate'")
        vehicle-fields(slot="n3", :item="item", :fieldName="'vehicle-fuel-type'")
        vehicle-status(slot="n4", :item="item", :showToolTip="false")
        vehicle-additional-status(slot="n4", :item="item", :showToolTip="false")
        div(slot="actionPage")
          router-link(:to="{name:'vehicle', params:{id:item.id}}")
            i.fa.fa-angle-right.fa-3x.action
    .card(v-if="$is('compact-card')")
      .inner-content
        .row
          .columns
          .columns.shrink
            dropdown(:icon="'fa fa-ellipsis-v fa-lg'", :position="'bottom'")
              vehicle-slot-buttons(:vehicle="item")
        .row
          .column.small-12.large-6
            h2.vehicle-info {{item.brand}} {{item.model}}
            router-link(:to="{name:'vehicle', params:{id:item.id}}")
              h1 {{item.plate}}
            router-link(v-if="item.parking_lot.id", :to="{name:'parkingLot', params:{id:item.parking_lot.id}}")
              h4 PL{{item.parking_lot.id}} {{item.parking_lot.name}}
            h4 VS{{item.slot_id}} {{item.vehicle_slot_address}}
          .column.small-12.large-6
            img(:src="item.picture_external")
            vehicle-status(:item="item")
            .text-center
              slot
    .card(v-if="$is('vehicle-card')")
      .inner-content
        .row
          .columns
            p Vehicle Information
            p CREATED AT {{ item.created_at }}
            span(v-if = "item.archived_at")
              p( style="color:red") ARCHIVED AT {{ item.archived_at }}
              p TIME IN ASSET {{$dateDifference(item.created_at, item.archived_at)}}

          .columns.shrink
            dropdown(:icon="'fa fa-ellipsis-v fa-lg'", :position="'bottom'")
              vehicle-slot-buttons(:vehicle="item")
        .row
          .column.small-12
            h2.vehicle-info {{item.brand}} {{item.model}}
            h2 {{item.color}} - {{item.category.name}}
            small VS{{item.slot_id}} - {{item.slot_name}} - {{item.vehicle_slot_address}}
            small(v-if="item.segment") SG{{item.segment.id}} {{item.segment.name}}
            .test(style="position:relative")
              img(:src="item.picture_external")
              .text-center
                router-link(:to="{name:'vehicle', params:{id:item.id}}")
                  h1 {{item.plate}}
              vehicle-status(:item="item")
              vehicle-additional-status(:item="item")


    .card.card-section(v-if="$is('parking-lot-assignment')")
      span Parking lot assignment
      router-link(v-if="item.parking_lot.id", :to="{name:'parkingLot', params:{id:item.parking_lot.id}}")
        h4 {{item.parking_lot.name}}


    .card(v-if="$is('replace-listing')")
      .inner-content
        cardN(:showBullets="true", :showAction="true", :columns="7")
          dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'", slot="actionBullets")
            slot(name="actionBullets")
          vehicle-fields(slot="n1", :item="item", :fieldName="'vehicle-image'")
          vehicle-fields(slot="n2", :item="item", :fieldName="'vehicle-id'")
          vehicle-fields(slot="n2", :item="item", :fieldName="'vehicle-brand-and-lot'")
          vehicle-fields(slot="n3", :item="item", :fieldName="'vehicle-plate'")
          vehicle-fields(slot="n4", :item="item", :fieldName="'vehicle-fuel-type'")
          vehicle-fields(slot="n5", :item="item", :fieldName="'vehicle-category'")
          vehicle-fields(slot="n6", :item="item", :fieldName="'vehicle-lot'")
          vehicle-fields(slot="n7", :item="item", :fieldName="'vehicle-status'")

    .card(v-if="$is('quick-booking')")
      .inner-content
        cardN(:showBullets="true", :showAction="true", :columns="4")
          vehicle-fields(slot="n1", :item="item", :fieldName="'vehicle-brand'")
          div(slot="n1")
            span
              img(:src="item.picture_external", width="100")
          vehicle-fields(slot="n1", :item="item", :fieldName="'vehicle-lot'")
          vehicle-fields(slot="n2", :item="item", :fieldName="'vehicle-plate'")
          vehicle-fields(slot="n3", :item="item", :fieldName="'vehicle-fuel-type'")
          vehicle-status(slot="n4", :item="item", :showToolTip="false")
          vehicle-additional-status(slot="n4", :item="item", :showToolTip="false")
          div(slot="actionPage")
            button.button.small(@click="$emit('bookVehicle', item)") Book
    .row.vehicle-card-row(v-if="$is('search-result')")
      .columns.small-10.text-center.vehicle-card
        .image(style="max-width:12em;margin:0 auto")
          img(:src="item.picture_external")
        h2 {{item.brand}} {{item.model}}
        div.distance(v-if="item.distance")
          p distance: {{item.distance}}{{configuration.locale.locale_distance_unit.value}}
        //vehicle-fields.vehicle-card-fields(:item="item", :fieldName="'vehicle-lot-address'")
        vehicle-fields.vehicle-card-fields(:item="item", :fieldName="'vehicle-plate'")
        vehicle-status.vehicle-card-fields(slot="n4", :item="item", :showToolTip="false")
        vehicle-additional-status.vehicle-card-fields(slot="n4", :item="item", :showToolTip="false")
        slot
          button.button.small(@click="$emit('bookVehicle', item)") Book
    .inner-content.federation-list(v-if="$is('federationList')")
      .row
        .column
          vehicle-fields(:item="item", :fieldName="'vehicle-id'")
          vehicle-fields(:item="item", :fieldName="'vehicle-brand-and-lot'")
        vehicle-fields.column(:item="item", :fieldName="'vehicle-category'")
        vehicle-fields.column(:item="item", :fieldName="'vehicle-plate'")
        vehicle-fields.column(:item="item", :fieldName="'vehicle-lot'")
</template>
<script type="text/babel">
import CardN from 'components/structure/CardN'
import Dropdown from 'components/structure/foundation/Dropdown'
import VehicleStatus from 'components/structure/ui/VehicleStatus'
import VehicleAditionalStatus from "../structure/ui/VehicleAdditionalStatus";
import VehicleAdditionalStatus from "../structure/ui/VehicleAdditionalStatus";
import VehicleSlotButtons from 'components/structure/ui/actions/VehicleSlotButtons'
import VehicleHardware from './VehicleHardware'
import VehicleFields from '../structure/ui/entity-fields/VehicleFields.vue'
import ModalReveal from '../structure/foundation/ModalReveal'
import CreateVehicleSlot from '../structure/ui/actions/asset-management/CreateVehicleSlot'
import ParkingLot from 'components/backoffice/ParkingLot'
import {mapState} from 'vuex'

export default {
  name: 'Vehicle',
  components: {
    VehicleAdditionalStatus,
    ParkingLot,
    CreateVehicleSlot,
    ModalReveal,
    CardN,
    VehicleFields,
    VehicleHardware,
    VehicleSlotButtons,
    VehicleStatus,
    VehicleAditionalStatus,
    Dropdown
  },
  data() {
    return {}
  },
  created() {
  },
  methods: {},
  props: {
    item: Object,
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      configuration: state => state.configuration,
    }),
  }
}
</script>
<style lang="sass" rel="stylesheet/sass">
.component-backoffice-vehicle-slot
  width: 100%

  .one-look
    text-align: center
    display: flex
    flex-direction: column
  .federation-list
  //display: flex
  position: relative

  .column-n1
    flex: 1 1 0

  .column-n3
    flex: 0 1 0

  .column-n5
    flex: 0 1 0

  .fleet-map
    .column, .columns
      flex: 1 1 auto

    .row
      flex-flow: nowrap !important

    .field-vehicle-status
      width: 10em
      text-align: end
      padding: 1em 2em
      box-sizing: content-box

    .field-vehicle-plate
      a.button
        margin: 0

  h3.fuel-info
    text-align: center

    span
      display: block

  .vehicle-card-row
    align-items: center
    justify-content: center

    .vehicle-card
      background-color: #f5f5f5
      margin: 10px

    .vehicle-card-fields
      margin: auto

  .distance
    font-size: 1em
    margin: 0 auto 10px auto

    p
      margin: 0

</style>



// WEBPACK FOOTER //
// Vehicle.vue?484e74b8